// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a44bd57a","455":"7802fd63","977":"22b45b3d"}[chunkId] + ".chunk.js";
};